import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBlogListing } from "../services/blogListService";

// Async thunk to fetch blogs
export const fetchblogThunk = createAsyncThunk(
  "blog/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getBlogListing();
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch blog");
    }
  }
);

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    resetblog: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchblogThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchblogThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchblogThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetblog } = blogSlice.actions;
export default blogSlice.reducer;
